import { useCallback, useEffect, useMemo, useState } from "react";

export function useSlideOverSearch<T>(
  open: boolean,
  items: T[],
  matchesSearch: (item: T, search: string) => boolean,
) {
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (open) setSearch("");
  }, [open]);

  // Exposed alongside visibleItems for consumers that must keep rendering every item at
  // its original index (e.g. to keep a remove-by-index handler correct) and so can't
  // switch to a filtered array — they call isVisible(item) inline instead.
  const isVisible = useCallback(
    (item: T) => matchesSearch(item, search),
    [matchesSearch, search],
  );

  const visibleItems = useMemo(
    () => items.filter(isVisible),
    [items, isVisible],
  );

  return { search, setSearch, visibleItems, isVisible };
}
